export const StatisticOptions = [
    {
        text: "Student Views",
        value: "statistics",
        key: 0
    },
    {
        text: "Pronunciation Data",
        value: "pronunciationAssignments",
        key: 1
    },
    {
        text: "Translation Flash Card Data",
        value: "translationFCAssignments",
        key: 3
    },
    {
        text: "Dialog Flash Card Data",
        value: "dialogFCAssignments",
        key: 4
    },
    // {
    //     text: "Dialog Practice Data",
    //     value: "dialogAssignments",
    //     key: 2
    // },
    {
        text: "Translation Practice Data",
        value: "quizAssignments",
        key: 5
    }
]
